import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"
const addProcessing = (parameter1, process_name, parameter2) => {
  return axios.post(API + "processing/createProcess/", {
    parameter1,
    process_name,
    parameter2,
  },{headers: authHeader(),});
};
const AddProcessingService = {
    addProcessing,
  };
  export default AddProcessingService;